'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');
var style = require('../../transformers/style.js');
var index = require('../SelectItem/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Container = styled__default["default"](index["default"]).withConfig({
  componentId: "sc-1vur0h4-0"
})(_ref => {
  let {
    disabled,
    layout
  } = _ref;
  return {
    textAlign: layout && layout === 'vertical' ? 'center' : 'left',
    display: 'flex',
    flexDirection: layout && layout === 'vertical' ? 'column' : 'row',
    alignItems: 'center',
    gap: '16px',
    width: '100%',
    ...(disabled ? {
      opacity: 0.5
    } : {})
  };
});
const ItemInfo = styled__default["default"].div.withConfig({
  componentId: "sc-1vur0h4-1"
})(["display:flex;flex-direction:column;gap:4px;padding:0px;flex:1;"]);
const ItemInfoDetail = styled__default["default"].p.withConfig({
  componentId: "sc-1vur0h4-2"
})(["display:flex;justify-content:", ";align-items:center;padding:", ";gap:8px;margin:0;", " font-weight:", ";@media screen and (max-width:768px){", "}"], _ref2 => {
  let {
    layout
  } = _ref2;
  return layout && layout === 'vertical' ? 'center' : 'flex-start';
}, _ref3 => {
  let {
    padding
  } = _ref3;
  return padding || '0px';
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return style.getFontSizing(theme.bodytextDefaultNone, {
    fontSize: '14px',
    lineHeight: '20px'
  });
}, _ref5 => {
  let {
    fontWeight
  } = _ref5;
  return fontWeight || 'inherit';
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return style.getFontSizing(theme.captiontextDefaultNone, {
    fontSize: '12px',
    lineHeight: '16px'
  });
});
const ItemName = styled__default["default"].h4.withConfig({
  componentId: "sc-1vur0h4-3"
})(["", " margin:0;padding:0 0 4px;@media screen and (max-width:768px){", "}"], _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.headersMediumNone;
}, _ref8 => {
  let {
    theme
  } = _ref8;
  return theme.headersSmallNone;
});

exports.Container = Container;
exports.ItemInfo = ItemInfo;
exports.ItemInfoDetail = ItemInfoDetail;
exports.ItemName = ItemName;
